import { UIText2 } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as styles from './ContactsDisclaimer.css';

export const ContactsDisclaimer = () => {
  return (
    <div className={styles['disclaimer']}>
      <IconCommunicationPhone16 />
      <UIText2>Номер только для звонков, сообщения не дойдут</UIText2>
    </div>
  );
};
